import React from 'react';
import { useSelector } from 'react-redux';

import SmartImage from 'dpl/components/SmartImage';

import womanWithDog from 'dpl/assets/pages/puppy_college/woman_with_dog.png';

export default function PuppyCollegeMission() {
  const mission = useSelector(({ server }) => server.mission);
  return (
    <div className="PuppyCollegeMission bg-sand">
      <div className="container">
        <div className="flex-l db items-center">
          <div className="w-60-lg w-100 pr12-lg">
            <h3 className="fw-normal md:font-40 xs:font-28 mb3 lh-title">
              {mission.title}
            </h3>
            <p className="secondary font-18">{mission.description}</p>
          </div>
          <div className="w-40-lg w-100 pl12-lg pl0">
            <SmartImage src={womanWithDog} />
          </div>
        </div>
      </div>
    </div>
  );
}
